import { useEffect, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Story from "@/components/Story";
import VolunteersBanner from "@/components/VolunteersBanner";
import Impact from "@/components/Impact";
import Donate from "@/components/Donate";
import Team from "@/components/Team";
import SanDiego from "@/components/SanDiego";
import Forms from "@/components/Forms";
import Footer from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const navigate = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -70, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="grain min-h-screen bg-[#FBF3E3] text-[#16294B]">
      <Navbar onNavigate={navigate} />
      <main>
        <Hero onNavigate={navigate} />
        <Marquee />
        <Manifesto />
        <Story />
        <VolunteersBanner onNavigate={navigate} />
        <Impact />
        <Donate />
        <Team />
        <SanDiego />
        <Forms />
      </main>
      <Footer onNavigate={navigate} />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
